<div class="input-field slide-toggle" [formGroup]="parentFormGroup">
	<mat-slide-toggle color="primary"
					  [formControlName]="nazevPrvkuFormulare"
					  [required]="jeHodnotaPovinna()"
					  [attr.disabled]="vypnoutPrvekFormulare()">{{ popisek | lokalizace }}</mat-slide-toggle>
	<mat-hint *ngIf="!pripravitErrorZpravu()">{{ napoveda | lokalizace }}</mat-hint>
	<mat-error>{{ pripravitErrorZpravu() }}</mat-error>
</div>
